import { createContext, useContext, useEffect, useMemo, useState, type ReactNode } from 'react';
import {
  DEFAULT_API_URL,
  DEFAULT_CONSENSUS_URL,
  DEFAULT_INDEXER_URL,
  setConsensusUrlOverride,
} from './client';

interface ConnectionCtx {
  apiUrl: string;
  indexerUrl: string;
  consensusUrl: string;
  setApiUrl: (u: string) => void;
  setIndexerUrl: (u: string) => void;
  setConsensusUrl: (u: string) => void;
}

const Ctx = createContext<ConnectionCtx | null>(null);

export function ConnectionProvider({ children }: { children: ReactNode }) {
  const [apiUrl, setApiUrl] = useState(DEFAULT_API_URL);
  const [indexerUrl, setIndexerUrl] = useState(DEFAULT_INDEXER_URL);
  const [consensusUrl, setConsensusUrl] = useState(DEFAULT_CONSENSUS_URL);

  useEffect(() => {
    setConsensusUrlOverride(consensusUrl);
  }, [consensusUrl]);

  const value = useMemo<ConnectionCtx>(
    () => ({ apiUrl, indexerUrl, consensusUrl, setApiUrl, setIndexerUrl, setConsensusUrl }),
    [apiUrl, indexerUrl, consensusUrl],
  );

  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useConnection() {
  const ctx = useContext(Ctx);
  if (!ctx) throw new Error('useConnection must be used within ConnectionProvider');
  return ctx;
}
